import { render, staticRenderFns } from "./EstimateCost.vue?vue&type=template&id=b5dffb6c&scoped=true&"
import script from "./EstimateCost.vue?vue&type=script&lang=js&"
export * from "./EstimateCost.vue?vue&type=script&lang=js&"
import style0 from "./EstimateCost.vue?vue&type=style&index=0&id=b5dffb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dffb6c",
  null
  
)

export default component.exports